import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { CashRegisterEntity } from '../../../../../models/entity/cash-register/cash-register-entity';
import { OmnisoftLoginRequest } from './model/login/omnisoft-login-request';
import { OmnisoftLoginRequestData } from './model/login/omnisoft-login-request-data';
import { OmnisoftCheckData } from './model/common/omnisoft-check-data';
import { OmnisoftCheckTypeEnum } from './enum/omnisoft-check-type.enum';
import { OmnisoftLoginResponse } from './model/login/omnisoft-login-response';
import { ICashRegisterVendorInterface } from '../../cash-register-vendor.interface';
import { LocalAppService } from '../../../../app/local-app.service';
import { CashRegisterCloseShiftLocalResponse } from '../../../../../models/rest/cash-register/close_shift/cash-register-close-shift-local-response';
import { CashRegisterXReportLocalResponse } from '../../../../../models/rest/cash-register/report/x-report/cash-register-x-report-local-response';
import { CashRegisterZReportBulkLocalResponse } from '../../../../../models/rest/cash-register/report/z-report/cash-register-z-report-bulk-local-response';
import { CashRegisterControlTapeLocalResponse } from '../../../../../models/rest/cash-register/control-tape/cash-register-control-tape-local-response';
import { CashRegisterPairLocalResponse } from '../../../../../models/rest/cash-register/pair/cash-register-pair-local-response';
import { StringUtils } from '../../../../../utils/string.utils';

@Injectable({
  providedIn: 'root'
})
export class OmnisoftService implements ICashRegisterVendorInterface {

  private baseUrl: string = '';
  private token?: string;
  appName = "OMNISOFT";
  timeout: 30;

  constructor(private http: HttpClient,
    private localAppService: LocalAppService
  ) { }
  pair(cashRegister: CashRegisterEntity, data: CashRegisterPairLocalResponse) {
    throw new Error('Method not implemented.');
  }
  controlTape(cashRegister: CashRegisterEntity, data: CashRegisterControlTapeLocalResponse) {
    throw new Error('Method not implemented.');
  }

  getDeviceInfo(cashRegister: CashRegisterEntity) {
    throw new Error('Method not implemented.');
  }
  setToken(cashRegister: CashRegisterEntity, token?: string) {
    this.token = token;
  }

  getToken(data: CashRegisterEntity) {
    return this.token;
  }

  isLoggedIn(data: CashRegisterEntity): boolean {

    return StringUtils.isNotEmpty(this.token);
  }

  setBaseUrl(data: CashRegisterEntity) {
    if (StringUtils.isEmpty(data.apiUrl)) {
      throw new Error("Yazar kasa ip adresi boş olamaz");
    }
    this.baseUrl = data.apiUrl!;

    if (!this.baseUrl.includes(":8989"))
      this.baseUrl = this.baseUrl + ":8989";

    if (!this.baseUrl.includes("/v2"))
      this.baseUrl = this.baseUrl + "/v2";

    if (!this.baseUrl.startsWith("http://")) {
      this.baseUrl = "http://" + this.baseUrl;
    }

  }

  async login(cashRegister: CashRegisterEntity) {
    this.setBaseUrl(cashRegister);
    const requestData = new OmnisoftLoginRequestData();
    requestData.name = cashRegister.userName ?? "";
    requestData.password = cashRegister.password ?? "";
    requestData.checkData = new OmnisoftCheckData(OmnisoftCheckTypeEnum.LOGIN);

    const request = new OmnisoftLoginRequest();
    request.requestData = requestData;

    const response = await firstValueFrom(
      this.localAppService.post(this.baseUrl, JSON.stringify(request), { 'Content-Type': 'application/json' }, this.timeout)
    );

    const res: OmnisoftLoginResponse = JSON.parse(response.data);

    if (res.code !== 1) {
      throw new Error(this.appName + ':Login->' + res.code + res.message);
    }

    console.log('res.access_token:' + res.access_token);

    this.setToken(cashRegister, res.access_token);
    return res;
  }
  private async handleRequest(
    cashRegister: CashRegisterEntity,
    request: any,
    action: () => Promise<any>
  ) {
    this.setBaseUrl(cashRegister);

    let oldToken = this.token;

    let response = await action();
    let res = JSON.parse(response.data);

    if (res.code === 0) {
      return res;
    }

    if (res.code === 401) {
      await this.login(cashRegister);
      request.data.replace(oldToken, this.token);
      response = await action();
      return JSON.parse(response.data);
    }

    return res;
  }

  async createSale(cashRegister: CashRegisterEntity, request: any) {
    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl, request.data, { 'Content-Type': 'application/json' }, this.timeout)
      )
    );
  }

  async cancelSale(cashRegister: CashRegisterEntity, request: any) {
    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl, request.data, { 'Content-Type': 'application/json' }, this.timeout)
      )
    );
  }
  async openShift(cashRegister: CashRegisterEntity, request: any) {
    this.setBaseUrl(cashRegister);

    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl, request.data, { 'Content-Type': 'application/json' }, this.timeout)
      )
    );
  }



  async closeShift(cashRegister: CashRegisterEntity, request: CashRegisterCloseShiftLocalResponse) {
    this.setBaseUrl(cashRegister);

    return this.handleRequest(cashRegister, request, () =>
      firstValueFrom(
        this.localAppService.post(this.baseUrl, request.data!, { 'Content-Type': 'application/json' }, this.timeout)
      )
    );
  }

  getXReport(cashRegister: CashRegisterEntity, data: CashRegisterXReportLocalResponse) {
    throw new Error('Method not implemented.');
  }
  getZReport(cashRegister: CashRegisterEntity, data: CashRegisterZReportBulkLocalResponse) {
    throw new Error('Method not implemented.');
  }

}
